module.exports = __webpack_public_path__ + "static/img/banner.d629db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/banner.png
// module id = Sp2j
// module chunks = 2